import React from 'react';
import {checkValidation, handleUserSave} from "../../API/benutzermanagement";
import {Row} from "react-bootstrap/esm/index";
import {Save, X} from "react-feather";
import {Button, Col, Container, Form, Modal} from "react-bootstrap";
import UserModal from "./UserModal";

const UserDetailsModal = (elem) => {
    return (
        <div>
            <Modal size="md" aria-labelledby="contained-modal-title-vcenter"
                   centered
                   animation={false}
                   show={elem.props.editUserModalShow}
                   onHide={() => elem.changeState({editUserModalShow: false})}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Handwai | Benutzerdetails</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>

                        {elem.props.displayStatus &&
                        <Container>
                            <br/>
                            <Row>
                                <Col>
                                    <Form.Group as={Row} controlId="formEditStatus">
                                        <Form.Label column sm="3">Status</Form.Label>
                                        <Col sm={6}><Form.Control
                                            className="userdetailscheckbox" label="Status"
                                            type="checkbox"
                                            defaultChecked={elem.props.editUserData.items.st}
                                            onChange={e => elem.handleModalStatusChange(e)}
                                        /></Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>}
                        <UserModal props={elem.props} onSelectedGenderChange={elem.onSelectedGenderChange}
                                   updateNameForm={elem.updateNameForm}
                                   onSelectedRoleChange={elem.onSelectedRoleChange} usermodal='UserDetailsModal'
                                   onSelectedBusinessRoleChange={elem.onSelectedBusinessRoleChange}
                                   onSelectedCompanyChange={elem.onSelectedCompanyChange}
                                   changeState={elem.changeState}/>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={!checkValidation(elem.props)} size="lg" block variant="outline-success"
                            onClick={() => {
                                elem.changeState({editUserModalShow: false})
                                handleUserSave(elem.props, elem.changeState, 0)}}><Save/>&nbsp;&nbsp;Speichern</Button>

                    <Button size="lg" variant="outline-dark" style={{width: "100%"}}
                            onClick={() => elem.changeState({editUserModalShow: false})}><X/>
                        &nbsp;&nbsp;Abbrechen
                    </Button>
                </Modal.Footer>

            </Modal>
        </div>
    )
};

export default UserDetailsModal